export const GAMBLE_RESPONSE_DEFAULTS: any = {};
